import Request from './request';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from '../defaults/FieldNames.json';
import GeneralService from './GeneralService';
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const FundingService = {
    getFundingByJoinID: function (joinId, joinFeature, outFields = "*") {
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
        let whereClause = `((${FieldNames.fundingFields.joinID} = ${joinId}) AND (${FieldNames.fundingFields.joinFeature} = '${joinFeature}'))`;

        const queryObject = new Query({
          where: whereClause,
          outFields: outFields,
        });

        return query.executeQueryJSON(url, queryObject).then(results => {
          let fundingItems = [];
          if(results.features) {
            fundingItems = results.features.map((eaItem) => eaItem.attributes);
          } 
          return(fundingItems)
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getFundingByJoinIDs: function (joinIDs, joinFeature) {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
        let whereClause = "1=1";
        if(joinIDs && joinIDs.length > 0){
          whereClause = `(JoinID IN (${joinIDs.join(", ")}) AND (${FieldNames.fundingFields.joinFeature} = '${joinFeature}'))`
          const queryObject = new Query({
            where: whereClause,
            outFields: "*",
          });
    
          return query.executeQueryJSON(url, queryObject).then(results => {
            let fundingItems = [];
            if(results.features) {
              fundingItems = results.features.map((eaItem) => eaItem.attributes);
            } 
            return(fundingItems)
          });
        }
        else
        {
          return new Promise((resolve) => {
            resolve([]);
          })
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
   
    updateFundingEntries: function (fundingEntries){
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();
        
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/updateFeatures";
        return new Promise((resolve, reject) => {
          let adjustedFundingEntries = [];
          fundingEntries.forEach((feature) => {
            const newFundingEntry = {
              attributes: feature
            };
            adjustedFundingEntries.push(newFundingEntry);
          });
            
          new Request().makeRequest({
            url: url,
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify(adjustedFundingEntries)
            }
          }).then(
              resp => {
                resolve(resp);
              },
              error => {
                reject(error)
              }
          );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    addFundingEntries: function (fundingEntries){
      try
      {
        //Can only update 1 type at a time due to url being different
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();

        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/addFeatures";
        return new Promise((resolve, reject) => {
            let adjustedFundingEntries = [];
            fundingEntries.forEach((feature) => {
              const newFundingEntry = {
                attributes: feature
              };
              adjustedFundingEntries.push(newFundingEntry);
            });
              
            new Request().makeRequest({
              url: url,
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify(adjustedFundingEntries)
              }
            }).then(
                resp => {
                  resolve(resp);
                },
                error => {
                  reject(error)
                }
            );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    deleteFundingEntries: function (fundingEntryObjectIds){
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/deleteFeatures";
        return new Promise((resolve, reject) => {
          const whereArray = [];
          fundingEntryObjectIds.forEach((objectId) => {
            const indWhere = `(OBJECTID=${objectId})`
            whereArray.push(indWhere);
          });
          const whereClause = "(" + whereArray.join(" OR ") + ")";
          new Request().makeRequest({
            url: url,
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                where: whereClause
            }
        }).then(
            resp => {
                resolve(resp)
            },
            error => {
              reject(error)
            }
        );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
};

export default FundingService;